var _mask, _path, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 510,
    height: 241,
    viewBox: "0 0 510 241",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_499_218",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.00973e-05 115.5C8.77133e-06 130.668 2.98751 145.687 8.79195 159.7C14.5964 173.713 23.1041 186.446 33.8293 197.171C44.5545 207.896 57.2872 216.404 71.3004 222.208C85.3135 228.013 100.333 231 115.5 231L115.5 178.401C107.24 178.401 99.0604 176.774 91.4289 173.613C83.7973 170.452 76.8631 165.819 71.0221 159.978C65.1812 154.137 60.5479 147.203 57.3868 139.571C54.2257 131.94 52.5987 123.76 52.5987 115.5L1.00973e-05 115.5Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00973e-05 115.5C8.77133e-06 130.668 2.98751 145.687 8.79195 159.7C14.5964 173.713 23.1041 186.446 33.8293 197.171C44.5545 207.896 57.2872 216.404 71.3004 222.208C85.3135 228.013 100.333 231 115.5 231L115.5 178.401C107.24 178.401 99.0604 176.774 91.4289 173.613C83.7973 170.452 76.8631 165.819 71.0221 159.978C65.1812 154.137 60.5479 147.203 57.3868 139.571C54.2257 131.94 52.5987 123.76 52.5987 115.5L1.00973e-05 115.5Z",
    stroke: "black",
    strokeWidth: 2,
    mask: "url(#path-1-inside-1_499_218)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 432,
    y1: 240,
    x2: 510,
    y2: 240,
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.914161be1e91936a95cbc02fd9f26e30.svg";
export { ForwardRef as ReactComponent };